import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Card, Sticker } from "@/components/ui-brutal";
import {
  UserCircle, Buildings, Airplane, DiscordLogo,
  Gift, Confetti, Article, ShieldStar, CaretRight, CurrencyCircleDollar, CreditCard, SignOut, Trophy,
} from "@phosphor-icons/react";

// Color rotation: red (primary) → white → gold (accent)
const PALETTE = ["bg-[var(--primary)] text-white", "bg-white", "bg-[var(--accent)]"];

const TILES = [
  { to: "/dashboard/profile",          label: "Profile",             icon: UserCircle,  desc: "From your rintaki.org account" },
  { to: "/dashboard/trips",            label: "Trips & conventions", icon: Airplane,    desc: "Members-only travel" },
  { to: "/dashboard/points-guide",     label: "Points guide",        icon: Trophy,      desc: "How to earn & spend" },
  { to: "/dashboard/anime-cash-guide", label: "Anime Cash guide",    icon: CurrencyCircleDollar, desc: "How Anime Cash works" },
  { to: "/dashboard/library-guide",    label: "Library guide",       icon: Buildings,   desc: "Borrow & return rules" },
  { to: "/dashboard/giveaways?type=anime_item", label: "Anime Give Away",      icon: Gift, desc: "Monthly anime prizes" },
  { to: "/dashboard/giveaways?type=gift_card",  label: "Gift Card Give Away",  icon: Gift, desc: "Monthly gift cards" },
  { to: "/dashboard/catalog",          label: "Catalog",             icon: CreditCard,  desc: "Members-only products" },
  { to: "/dashboard/contests",         label: "Contests",            icon: Confetti,    desc: "Members-only" },
  { to: "/dashboard/discord",          label: "Discord",             icon: DiscordLogo, desc: "Private server" },
  { to: "/dashboard/submit-article",   label: "Article Submission",  icon: Article,     desc: "Blog / magazine" },
];

export default function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => {
    // Navigate to the public home FIRST so the <Protected> wrapper on /dashboard
    // doesn't redirect to /login the moment setUser(null) fires.
    navigate("/", { replace: true });
    await logout();
  };

  return (
    <div className="space-y-5">
      <div>
        <div className="flex items-center justify-between gap-2">
          <Sticker color="accent"><ShieldStar size={12} weight="fill" /> Members only</Sticker>
          <button onClick={onLogout} data-testid="dash-logout"
                  className="inline-flex items-center gap-1 bg-white border-2 border-black rounded-full px-3 py-1.5 shadow-[2px_2px_0_#111] text-[10px] font-black uppercase tracking-widest active:translate-x-[1px] active:translate-y-[1px] active:shadow-none">
            <SignOut size={12} weight="bold" /> Log out
          </button>
        </div>
        <h1 className="font-black text-3xl mt-2">Hi {user?.name?.split(" ")[0]} 👋</h1>
        <p className="text-[var(--muted-fg)] text-sm">Your members-only hub.</p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {TILES.map((t, i) => (
          <Link key={t.to} to={t.to} data-testid={`dash-${t.label.toLowerCase().replace(/\s/g, '-')}`}>
            <Card className={`${PALETTE[i % PALETTE.length]} p-3 h-full`}>
              <t.icon size={22} weight="fill" />
              <div className="font-black mt-1 leading-tight">{t.label}</div>
              <div className="text-[11px] opacity-80">{t.desc}</div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
